import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useEntityCrud } from '../../hooks/useEntityCrud';

const DEFAULT_FORM = {
    title: ""
}


const ContactUs = () => {

    const [form, setForm] = useState(DEFAULT_FORM)

    const { addData: addConfig } = useEntityCrud("Config/update")
    const { readData } = useEntityCrud('Config/get');


    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        const body = {
            "key": "contactus"
        }
        readData(body).then(({ data }) => {
            if (data.status)
                setForm({
                    title: data.result.value
                })
        });
    }


    const handleChange = (e) => {
        const newForm = { ...form };
        newForm[e.target.name] = e.target.value
        setForm(newForm)
    }

    function handleSubmit(e) {
        e.preventDefault();
        const body = {
            "value": form.title,
            "key": "contactus"
        }
        addConfig(body)
            .then(({ data }) => {
                if (data.status) {
                    toast.success('عملیات مورد نظر با موفقیت انجام شد');
                } else
                    data.errors.map(error => toast.error(error.message));
            })
    }



 
    return (
        <div className=" baseInfo_" >
        <form onSubmit={handleSubmit} >
            <div className='row mx-auto' style={{ display: "flex", alignItems: "end" }}>
                <div className="col-md-12 pr-0">
                    <div className="form-group ">
                        <label>  متن  </label>
                        <textarea value={form.title} name={"title"} onChange={handleChange} type="text"
                            className="form-control mt-0" />
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="form-group mb-0">
                        <button className="btn btn-success px-4 btn-block">ذخیره اطلاعات </button>
                    </div>
                </div>
            </div>ّ
        </form>
    </div>
    );
}

export default ContactUs;